module.exports = __webpack_public_path__ + "img/20-avatar male.39a7cd4e.png";